import { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  IconButton,
  Popover,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Link as RouterLink } from "react-router-dom";

const services = [
  {
    title: "Zementestrich (CT)",
    img: "/services/zement.jpg",
    text: "Robuster und langlebiger Estrich für Wohn- und Gewerbebauten.",
    info: `Der Zementestrich ist die am häufigsten hergestellte Estrichart.\nEr ist dauerhaft feuchtigkeitsbeständig und kann im Innen- und Außenbereich\nsowie in Nassräumen eingesetzt werden. Früh belegbar (ab 24 Stunden möglich),\njedoch mit Verformungen während der Trocknung.`,
  },
  {
    title: "Calciumsulfat- / Anhydritestrich (CA)",
    img: "/services/anhydrit.jpg",
    text: "Ideal für Fußbodenheizungen und große Flächen.",
    info: `Calciumsulfat- bzw. Anhydritestrich eignet sich für Wohn- und Gewerbebauten\nim Innenbereich (außer Nassräume). Er härtet nahezu verformungsfrei aus und\nkann fugenlos auf großen Flächen verlegt werden. Nachteil sind längere\nTrocknungszeiten.`,
  },
  {
    title: "Dämmungen",
    img: "/services/daemmung.jpg",
    text: "Optimale Wärme- und Trittschalldämmung.",
    info: "Professionelle Wärme- und Trittschalldämmungen zur Verbesserung der Energieeffizienz und des Wohnkomforts.",
  },
  {
    title: "Abbrucharbeiten",
    img: "/services/abbruch.jpg",
    text: "Fachgerechter Rückbau und Entsorgung.",
    info: "Sicherer und fachgerechter Rückbau inklusive Entsorgung nach geltenden Vorschriften.",
  },
];

export default function Services() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [activeInfo, setActiveInfo] = useState<string>("");

  const handleOpen = (e: React.MouseEvent<HTMLElement>, info: string) => {
    setAnchorEl(e.currentTarget);
    setActiveInfo(info);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setActiveInfo("");
  };

  return (
    <>
      <Box
        sx={{
          py: 8,
          px: { xs: 2, md: 0 },
        }}
      >
        <Typography variant="h3" color="primary" sx={{ textAlign: 'center', mb: 6 }}>
          Unsere Leistungen
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(2, 1fr)",
            },
            gap: 4,
            maxWidth: 1000,
            width: "100%",
            mx: "auto"
          }}
        >
          {services.map((s) => (
            <Card key={s.title} sx={{ position: "relative", backgroundColor: "background.paper" }}>
              <IconButton
                size="small"
                onClick={(e) => handleOpen(e, s.info)}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  backgroundColor: "rgba(0,0,0,0.6)",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "primary.main",
                  },
                }}
              >
                <InfoOutlinedIcon fontSize="small" />
              </IconButton>

              <img
                src={s.img}
                alt={s.title}
                style={{
                  width: "100%",
                  height: 200,
                  objectFit: "cover",
                }}
              />

              <CardContent>
                <Typography variant="h5" color="primary">{s.title}</Typography>
                <Typography sx={{ mt: 2, color: "text.primary" }}>{s.text}</Typography>

                <Button
                  component={RouterLink}
                  to="/kontakt"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3 }}
                >
                  Anfrage senden
                </Button>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ p: 2, maxWidth: 300, backgroundColor: "background.paper" }}>
          <Typography sx={{ fontSize: 13, whiteSpace: "pre-line", color: "text.primary" }}>
            {activeInfo}
          </Typography>
        </Box>
      </Popover>
    </>
  );
}
